// -----------------------APPEARANCE-----------------------
export var DNAIconAppearanceEnum;
(function (DNAIconAppearanceEnum) {
    DNAIconAppearanceEnum["filled"] = "filled";
    DNAIconAppearanceEnum["outline"] = "outline";
    DNAIconAppearanceEnum["ghost"] = "ghost";
})(DNAIconAppearanceEnum || (DNAIconAppearanceEnum = {}));
export const DNAIconAppearanceKeys = Object.keys(DNAIconAppearanceEnum);
// --------------------------STATUS--------------------------
export var DNAIconStatusEnum;
(function (DNAIconStatusEnum) {
    DNAIconStatusEnum["primary"] = "primary";
    DNAIconStatusEnum["secondary"] = "secondary";
    DNAIconStatusEnum["subtle"] = "subtle";
    DNAIconStatusEnum["success"] = "success";
    DNAIconStatusEnum["warning"] = "warning";
    DNAIconStatusEnum["danger"] = "danger";
    DNAIconStatusEnum["transparent"] = "transparent";
    DNAIconStatusEnum["tertiary"] = "tertiary";
})(DNAIconStatusEnum || (DNAIconStatusEnum = {}));
export const DNAIconStatusKeys = Object.keys(DNAIconStatusEnum);
// --------------------------SIZE--------------------------
export var DNAIconSizeEnum;
(function (DNAIconSizeEnum) {
    DNAIconSizeEnum["sm"] = "sm";
    DNAIconSizeEnum["md"] = "md";
    DNAIconSizeEnum["lg"] = "lg";
    DNAIconSizeEnum["xl"] = "xl";
})(DNAIconSizeEnum || (DNAIconSizeEnum = {}));
export const DNAIconSizeKeys = Object.keys(DNAIconSizeEnum);
//# sourceMappingURL=DNAIcon.types.js.map